import { Button, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { SidebarHighlightCard } from '@/components/sidebar-highlight-card'
import { routes } from '@/router'

export function CreditSidebarCard() {
  return (
    <SidebarHighlightCard>
      <Typography variant="body2">Precisa de mais crédito?</Typography>
      <Button
        size="small"
        component={Link}
        to={routes.credit.index}
        sx={{ alignSelf: 'flex-start' }}
      >
        Ver produtos
      </Button>
    </SidebarHighlightCard>
  )
}
